// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:38:33

export default {
  "id": "art-salon",
  "slug": "art-salon",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/947a3ee54c2e4cbeac01c054a8647dae-512x384.jpeg",
  "gameUrl": "https://html5.gamedistribution.com/947a3ee54c2e4cbeac01c054a8647dae/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Art Salon",
      "description": "Welcome to Art Salon - Makeup & Nails, where your creativity knows no bounds! ? Whether you're passionate about fashion, beauty care, or just looking for a fun, relaxing game, this is the perfect app for you. From designing acrylic nails to creating stunning makeup looks, step into a world of endless beauty transformations in 3D! ??",
      "instructions": "Transform your clients from a mess to a princess with eye-catching makeup! Apply lipstick, blush, eyeshadow, and more. Experience satisfying ASMR as you create flawless looks. Perfect your techniques and go viral with your bold looks. ",
      "genres": [
        "Care",
        "Dress-up"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-CN": {
      "title": "艺术沙龙",
      "description": "欢迎来到艺术沙龙——美妆与指甲，你的创造力在这里无拘无束！？无论你对时尚、美容护理有多热爱，还是仅仅想找一款有趣、轻松的游戏，这个应用都是你的完美选择。从设计丙烯酸指甲到打造惊艳的妆容，进入一个无限美妆变形的3D世界！？",
      "instructions": "将你的客户从一团糟变成公主，用引人注目的妆容！涂抹口红、腮红、眼影等。在创造完美妆容的过程中体验令人满足的ASMR。磨炼你的技巧，用大胆的外观走红网络。",
      "genres": [
        "关怀",
        "装扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-TW": {
      "title": "藝術畫廊",
      "description": "歡迎來到藝術攝影室 - 美妝與指甲，讓你的創意無所拘束！不論你是對時尚、美容護理有熱情，還是只是尋找一個好玩、放鬆的遊戲，這款應用程式正是為你量身打造。從設計膠質指甲到創造驚艷的美妝造型，進入一個無盡的美麗變身3D世界！？",
      "instructions": "將您的顧客從亂七八糟變成公主，用引人注目的妝容！應用口红、妝顏、眼影等。在創造無懈可擊的顏值的同時，體驗滿足感十足的ASMR。精煉您的技巧，以您的大膽風格走红網絡。",
      "genres": [
        "關心",
        "裝飾打扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-HK": {
      "title": "藝術畫廊",
      "description": "歡迎來到藝術美妝吧 - 美甲，無限創意盡在掌握！不論你是對時裝、美容護理有熱情，還是尋找一個好玩、放鬆的遊戲，這款應用程式絕對適合你。從設計美甲到創造驚人的妝容，進入一個無盡的美麗變身3D世界！？",
      "instructions": "將客戶從亂糟糟變成公主，以驚艷的妝容為她們打扮！應用唇膏、胭脂、眼影等。在創造完美妆容的過程中體驗滿足的ASMR。磨練技巧，以你膽色十足的妆容走紅網絡！",
      "genres": [
        "小心",
        "打扮"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ja": {
      "title": "アート・サロン",
      "description": "アートサロン - メイク＆ネイルへようこそ！あなたのクリエイティビティには限界がありません！ファッションや美容 care に情熱を持っている方、または楽しいリラックスしたゲームを探している方にも最適なアプリです。アクリルネイルのデザインから驚きのメイクアップの作成まで、3D空間で無限のビューティートランスフォーメーションの世界へ入ってください！？",
      "instructions": "クライアントをごちゃごちゃからプリンセスに変身させ、目を引くメイクアップで！リップスタイン、ブローザー、アイシャドウなどを塗る。完璧なルックを作成するたびに満足するASMRを体験しよう。技術を磨き、大胆なルックでビラルになる！",
      "genres": [
        "心配",
        "ドレスアップ"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ko": {
      "title": "아트 사론",
      "description": "웰컴 투 아트 사론 - 메이크업 & 널스, 창의성의 한계 없는 곳! ? 패션, 빌리지 케어에 열중하시거나, 즐거움과 휴식을 추구하는 게임을 찾고 계신다면, 이 앱이 가장 적합합니다. 아크릴 널스 디자인부터 아름다운 메이크업 룩을 만들기까지, 3D beauty transformation의 끝없는 세계로 발걸음을 내디뎕하세요! ??",
      "instructions": "고객들을 혼란스러움에서 공주로 변화시키세요! 입술술, 발红的, 눈썹술, 그리고 더 많은 화장품을 응용하세요. 완벽한 외관을 만들면서 만족스러운 ASMR을 경험하세요. 기술을 완성하고 대담한 외관으로 인기를 끌세요.",
      "genres": [
        "주의",
        "의상 변신"
      ],
      "tags": [
        "10x10"
      ]
    },
    "fr": {
      "title": "Salon d'Art",
      "description": "Bienvenue dans Art Salon - Maquillage & Ongles, où votre créativité n'a pas de limites ! ? Que vous soyez passionné par la mode, les soins de beauté ou simplement à la recherche d'un jeu amusant et apaisant, cette application est faite pour vous. De la conception d'ongles en acrylique à la création de looks de maquillage époustouflants, plongez dans un monde d'infinites transformations de beauté en 3D ! ??",
      "instructions": "Transformez vos clients d'un désordre en une princesse avec un maquillage accrocheur ! Appliquez du rouge à lèvres, du blush, du fard à paupières et plus encore. Profitez d'une ASMR satisfaisante tout en créant des looks parfaits. Affinez vos techniques et devenez virale avec vos looks audacieux.",
      "genres": [
        "Prudence",
        "Déguisement"
      ],
      "tags": [
        "10x10"
      ]
    }
  }
};
